"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function About() {
  const {
    ref: textRef1,
    isVisible: isVisible1
  } = useRevealOnScroll({
    threshold: 0.3
  });
  const {
    ref: textRef2,
    isVisible: isVisible2
  } = useRevealOnScroll({
    threshold: 0.3
  });
  const {
    ref: textRef3,
    isVisible: isVisible3
  } = useRevealOnScroll({
    threshold: 0.3
  });
  return <section id="about" className="relative min-h-screen bg-background py-xl overflow-hidden">
      {}
      <div className="absolute inset-0 opacity-5 pointer-events-none">
        <svg width="100%" height="100%" xmlns="http://www.w3.org/2000/svg">
          <defs>
            <pattern id="grid" width="80" height="80" patternUnits="userSpaceOnUse">
              <path d="M 80 0 L 0 0 0 80" fill="none" stroke="currentColor" strokeWidth="1" className="text-primary" />
            </pattern>
          </defs>
          <rect width="100%" height="100%" fill="url(#grid)" />
        </svg>
      </div>

      <div className="container relative z-10">
        <div className="max-w-5xl mx-auto space-y-xl">
          {}
          <div ref={textRef1} className={`transition-opacity duration-slow ease-smooth ${isVisible1 ? "opacity-100" : "opacity-0"}`}>
            <h1 className="font-display text-[64px] md:text-[80px] lg:text-[96px] leading-[1.1] font-bold text-foreground tracking-tight mb-lg">
              Empowering French Speakers to Master Global Languages
            </h1>
          </div>

          {}
          <div ref={textRef2} className={`transition-opacity duration-slow ease-smooth ${isVisible2 ? "opacity-100" : "opacity-0"}`}>
            <p className="font-sans text-[28px] md:text-[36px] lg:text-[42px] leading-[1.4] text-foreground/90 font-light">
              Unity Language Academy was founded with a singular mission: to help French-speaking students unlock international opportunities through English and German language mastery.
            </p>
          </div>

          {}
          <div ref={textRef3} className={`transition-opacity duration-slow ease-smooth ${isVisible3 ? "opacity-100" : "opacity-0"}`}>
            <p className="font-sans text-[24px] md:text-[30px] lg:text-[36px] leading-[1.5] text-muted-foreground font-light">
              We specialize in IELTS and TOEFL preparation, alongside comprehensive English and German courses designed for academic excellence, professional growth, and successful immigration journeys. Our certified instructors combine communicative teaching methods with exam-focused strategies, ensuring every student achieves their language goals with confidence and clarity.
            </p>
          </div>
        </div>
      </div>
    </section>;
}